import { ReactElement } from 'react';

import { EmptyStatePlaceholder } from '@dreryk/react-components';

import { calendarTranslationKeys } from '../../../../translations';

import { TimetablePlaceholderTurnOffPreferencesLink } from './TimetablePlaceholderTurnOffPreferencesLink';

type TimetablePlaceholderProps = {
   showTurnOffLink?: boolean;
};

export const TimetablePlaceholder = (props: TimetablePlaceholderProps): ReactElement => {
   return (
      <EmptyStatePlaceholder
         testId={'calendarLimitedViewPlaceholder'}
         heading={calendarTranslationKeys.noScheduleNorVisits}
         subheading={calendarTranslationKeys.noScheduleNorVisitsInView}
      >
         {props.showTurnOffLink ? <TimetablePlaceholderTurnOffPreferencesLink /> : null}
      </EmptyStatePlaceholder>
   );
};
